import { z } from 'zod';
import { OVERTIME_MAX_CLIENT_EMAILS } from '../../../../shared/dpRequests';

export const dayOffFormSchema = z
    .object({
        managerEmail: z.string().trim().email('Escolha o gestor que vai aprovar'),
        reason: z.string().trim().max(500, 'O motivo pode ter no máximo 500 caracteres').optional(),
        noClient: z.boolean(),
        clientEmails: z
            .array(z.string().trim().email('Um dos e-mails do cliente é inválido'))
            .max(OVERTIME_MAX_CLIENT_EMAILS, `Informe no máximo ${OVERTIME_MAX_CLIENT_EMAILS} e-mails`),
    })
    .superRefine((value, context) => {
        if (!value.noClient && value.clientEmails.length === 0) {
            context.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['clientEmails'],
                message: 'Informe o e-mail do gestor do cliente ou marque que o projeto não tem cliente',
            });
        }
    });

export type DayOffFormValues = z.infer<typeof dayOffFormSchema>;
